<script>
  import InfoOutline from "@/components/partials/icons/InfoOutline.vue";

  export default {
    name: "BaseTooltip",
    components: { InfoOutline },
    props: {
      text: {
        type: String,
        default: "",
      },
      position: {
        type: String,
        default: "top",
      },
    },
    data() {
      return {
        tooltipStyle: {
          top: "0px",
          left: "0px",
        },
      };
    },
    watch: {
      text() {
        this.updateTooltipPosition();
      },
    },
    mounted() {
      this.updateTooltipPosition();
    },
    methods: {
      updateTooltipPosition() {
        const { tooltip } = this.$refs;
        // To calculate the bounding rectangle of the component's root element
        const parentRect = this.$el.getBoundingClientRect();
        // This is needed to determine the size of the tooltip so we can position it properly relative to its parent
        const tooltipRect = tooltip.getBoundingClientRect();

        let top = 0;
        let left = 0;

        if (this.position === "top") {
          // Adjusting by an additional 10 pixels to add some space between the tooltip and its parent.
          top = parentRect.top - tooltipRect.height - 10;
          // It centers the tooltip horizontally within its parent element
          left = parentRect.left + parentRect.width / 2 - tooltipRect.width / 2;
        }

        if (this.position === "right") {
          top = parentRect.top + (parentRect.height / 2) - (tooltipRect.height / 2);
          left = parentRect.right + 10;
        }

        this.tooltipStyle = {
          top: `${top}px`,
          left: `${left}px`,
        };
      },
    },
  };
</script>
<template>
  <div class="base-tooltip-box" @mouseenter="updateTooltipPosition">
    <slot>
      <InfoOutline color="var(--neutral-500)" />
    </slot>
    <div
      ref="tooltip" class="tooltip text-center"
      :style="tooltipStyle"
    >
      <slot name="text">
        <p
          v-show="text"
          class="arrow radius-8 p-y-6 p-x-9 bg-neutral-700 p-small-medium text-base-white"
          :class="`arrow-${position}`"
        >
          {{ text }}
        </p>
      </slot>
    </div>
  </div>
</template>
<style lang="sass" scoped>
.tooltip
  position: fixed
  display: grid
  place-items: center
  width: max-content
  max-width: 200px
  opacity: 0
  visibility: hidden
  transition: all .2s ease-in-out
  z-index: 5

  .arrow::after
    border-width: 5px
    border-style: solid
    border-color: var(--neutral-700) transparent transparent transparent
    content: ""
    position: absolute

  .arrow-top::after
    top: 100%
    left: 50%
    transform: translateX(-50%)

  .arrow-right::after
    top: 40%
    right: 100%
    transform: rotate(90deg)

.base-tooltip-box:hover .tooltip
  opacity: 1
  visibility: visible
</style>
